import { InjectionToken, Type } from '@angular/core';
import { TokenFactory } from './interfaces/bimplus-websdk/interfaces';

/**
 * Injection token for the Bimplus API token factory.
 * This factory is responsible for creating and managing authentication tokens for the Bimplus API.
 */
export const BIMPLUS_TOKEN_FACTORY = new InjectionToken<TokenFactory>('BIMPLUS_TOKEN_FACTORY');

/**
 * Injection token for the HTTP unauthorized error dialog component.
 * This component will be displayed when the application encounters an HTTP 401 Unauthorized error,
 * typically indicating that the user's authentication token has expired or is invalid.
 */
export const HTTP_UNAUTHORIZED_ERROR_DIALOG = new InjectionToken<Type<unknown>>(
  'HTTP_UNAUTHORIZED_ERROR_DIALOG'
);
